import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Loader from './components/ui/Loader';
import ErrorBoundary from './components/ui/ErrorBoundary';
import ScrollManager from './components/ui/ScrollManager';

import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';

import { lazyWithRetry } from './utils/lazyWithRetry';
const LandingDSF = lazyWithRetry(() => import('./components/LandingDSF'));
const ServiciosIA = lazyWithRetry(() => import('./components/ServiciosIA'));
const SonrisaRealDemo = lazyWithRetry(() => import('./components/demos/SonrisaRealDemo'));

const App: React.FC = () => {
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            console.warn('[DSF] pathname:', window.location.pathname);
        }
    }, []);

    return (
        <>
            <Helmet
                titleTemplate="%s | Digital SaaS Factory"
                defaultTitle="Digital SaaS Factory | AI Infrastructure Company"
            >
                <meta name="description" content="Digital SaaS Factory: Infraestructura SaaS e IA escalable para LATAM." />
            </Helmet>
            <ThemeProvider>
                <ToastProvider>
                    <BrowserRouter>
                        <ScrollManager />
                        <ErrorBoundary>
                            <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><Loader text="Cargando..." /></div>}>
                                <Routes>
                                    <Route path="/" element={<LandingDSF />} />
                                    <Route path="/servicios-ia" element={<ServiciosIA />} />
                                    <Route path="/servicios-ia/" element={<ServiciosIA />} />
                                    <Route path="/demos/sonrisa-real" element={<SonrisaRealDemo />} />
                                    <Route path="*" element={<Navigate to="/" replace />} />
                                </Routes>
                            </Suspense>
                        </ErrorBoundary>
                    </BrowserRouter>
                </ToastProvider>
            </ThemeProvider>
        </>
    );
};

export default App;
